import React from 'react';
import FileUploadTool from "../file-upload/FileUploadTool";
import ImageUploadParcel from "../../api/endpoints/image/ImageUploadParcel";
import ImageHelper from "../../helpers/ImageHelper";
import {IMAGE_EXTENSIONS, IMAGE_MAX_SIZE, IMAGE_MIME_TYPES} from "../../view-constants/files/image";


export default function ImageUploadTool(
    {
        maxFiles,
        onDone,
        onCancel,
    }
) {

    return <FileUploadTool
        FileUploadParcel={ImageUploadParcel}
        renderThumbnail={record => <img src={ImageHelper.getUrl(record)} alt={record.title}/>}
        maxFiles={maxFiles}
        maxFileSize={IMAGE_MAX_SIZE}
        allowedMimeTypes={IMAGE_MIME_TYPES}
        allowedExtensions={IMAGE_EXTENSIONS}
        onDone={onDone}
        onCancel={onCancel}
    />;
}
